import { Button } from '@/components/ui/button'
import {
  Dialog,
  DialogContent,
  DialogHeader,
  DialogTitle,
} from '@/components/ui/dialog'
import { Textarea } from '@/components/ui/textarea'
import { useEffect, useState } from 'react'
import type { DisplayOccupant } from './types'

type Props = {
  occupant: DisplayOccupant | null
  mutationPending: boolean
  onClose: () => void
  onSave: (occupantId: number, note: string) => void
}

const EditNoteModal = ({
  occupant,
  mutationPending,
  onClose,
  onSave,
}: Props) => {
  const [note, setNote] = useState('')

  useEffect(() => {
    setNote(occupant?.note ?? '')
  }, [occupant?.id, occupant?.note])

  return (
    <Dialog
      open={!!occupant}
      onOpenChange={(open) => {
        if (!open) onClose()
      }}
    >
      <DialogContent>
        <DialogHeader>
          <DialogTitle>Edit note</DialogTitle>
        </DialogHeader>
        <Textarea
          value={note}
          disabled={mutationPending}
          onChange={(event) => setNote(event.target.value)}
        />
        <div className='flex justify-end gap-2'>
          <Button variant='outline' onClick={onClose}>
            Cancel
          </Button>
          <Button
            disabled={!occupant || mutationPending}
            onClick={() => {
              if (!occupant) return
              onSave(occupant.id, note)
              onClose()
            }}
          >
            Save
          </Button>
        </div>
      </DialogContent>
    </Dialog>
  )
}

export default EditNoteModal
